<template>
	<div
		:class="
			`px-3 py-1 d-flex justify-space-between ${
				post.delReason ? 'red lighten-1 white--text' : 'grey lighten-3'
			}`
		"
	>
		<div class="no-flex">{{ post.delReason ? post.delReason.S : "" }}</div>
		<timeago :datetime="_getPostedDate(post.postedOn.N)" class="body-1 no-flex"></timeago>
	</div>
</template>

<script>
export default {
	name: "AnalyticsElInfo",
	props: ["post"],
	methods: {
		_getPostedDate(time) {
			return new Date(parseInt(time, 10) * 1000);
		}
	}
};
</script>
